<template>
    <div class="inline-block ">

        <select v-if="! selected" v-model="selected" @change="setQuery" class="w-32 mb-4 mr-2 py-1 px-2 text-xs bg-gray-300 rounded-full">
            <option :value="null" v-text="label"></option>
            <option v-for="(title, slug) in options" :key="slug" :value="slug" v-text="`${optionsPrefix} ${title}`"></option>
        </select>

        <div v-else class="inline-flex mb-4 mr-2 py-1 px-2 text-xs bg-gray-300 rounded-full">
            <span v-text="`${optionsPrefix} ${options[selected]}`"></span>
            <button @click="unsetQuery()" role="button" class="ml-2 pl-1 border-l border-gray-400 outline-none cursor-pointer">
                <icon name="x"/>
            </button>
        </div>

    </div>
</template>
<script>
export default {
    props: {
        options: {
            type: Object,
            required: true
        },
        queryName: {
            type: String,
            required: true
        },
        label: {
            type: String,
            default: '---'
        },
        optionsPrefix: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            selected: null
        }
    },
    methods: {
        setQuery() {
            Uri().addQuery(this.queryName, this.selected).redirect();
        },
        unsetQuery() {
            Uri().removeQuery(this.queryName).redirect();
        }
    },

    mounted() {
        this.selected = Uri().getQuery(this.queryName);
    }
}
</script>
